import { mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgBuildPipelinePhase } from "@/lib/manufacturing/buildPipelineTypes";
import type { MfgUnit } from "@/lib/manufacturing/types";
import { unitCanShipFromPlant } from "@/lib/manufacturing/shipFromPlant";

export function BuildPipelineUnitShipSection({
  unit,
  phases,
  busy,
  onShip,
}: {
  unit: MfgUnit;
  phases: readonly MfgBuildPipelinePhase[];
  busy: boolean;
  onShip: () => void;
}) {
  if (unit.staged_at) {
    const when = new Date(unit.staged_at).toLocaleString();
    return (
      <section>
        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Ship from plant
        </h3>
        <p className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-100">
          Shipped {when}. Delivery is not required to leave the board.
        </p>
      </section>
    );
  }

  const canShip = unitCanShipFromPlant(unit, phases);
  return (
    <section>
      <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Ship from plant
      </h3>
      <p className="mb-2 text-xs text-gray-500 dark:text-zinc-400">
        Marks the unit shipped and takes it off the active Kanban. Logistics / delivery
        can be scheduled later.
      </p>
      <button
        type="button"
        className={mfgPrimaryBtnClass}
        disabled={busy || !canShip}
        onClick={onShip}
      >
        {canShip ? "Ship from plant" : "Finish build first"}
      </button>
    </section>
  );
}
